
import {
  takeEvery, put, call, takeLatest, select,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { liveScoreStatus } from '../selectors/liveScoreStatus';
import { aGetLiveScoreStatusRequest, aUpdateLiveScoreStatusRequest } from '../reducers';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetLiveScoreStatusSuccess } from '../reducers/liveScoreStatus';

/**
 * @namespace sagas/liveScoreStatus
 *
 */
/**
 * @memberof sagas/liveScoreStatus
 * @typedef getliveScoreStatus/response.data
 * @type {object}
 */
/**
 * @memberof sagas/liveScoreStatus
 * @async
 */
function* getLiveScoreStatusSaga() {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_LIVE_SCORE_STATUS,
      value: true,
    }));

    response = yield call(requestGet, API_URLS.GET_LIVE_SCORE_STATUS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetLiveScoreStatusSuccess({
        liveScoreStatus: response.data,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_LIVE_SCORE_STATUS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.message || MODALS.GENERAL_ERROR,
      errorMessage: error.message || MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_LIVE_SCORE_STATUS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateLiveScoreSaga(action) {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_LIVE_SCORE_STATUS,
      value: true,
    }));
    const updatedLiveScore = action.payload;
    const response = yield call(requestPost, API_URLS.UPDATE_LIVE_SCORE_STATUS,
      action.payload, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      const listLiveScoreStatus = yield select(liveScoreStatus);
      const index = listLiveScoreStatus.findIndex(
        (liveScore) => liveScore.competitionId === updatedLiveScore.competitionId,
      );
      listLiveScoreStatus[index] = updatedLiveScore;
      yield put(aGetLiveScoreStatusSuccess({
        liveScoreStatus: listLiveScoreStatus,
      }));
      yield put(aSetOpenModal({
        modal: MODALS.SUCCESS,
        modalData: {
          message: SUCCESS_MODALS.UPDATE_LIVE_SCORE_STATUS,
          additionalMessage: 'successfully',
          modal: SUCCESS_MODALS.UPDATE_LIVE_SCORE_STATUS,
        },
      }));
      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.UPDATE_LIVE_SCORE_STATUS,
        value: false,
      }));
    }
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.message || MODALS.GENERAL_ERROR,
      errorMessage: error.message || MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_LIVE_SCORE_STATUS,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/liveScoreStatus
 * @async
 * @returns {void}
 */
export default function* liveScoreStatusSaga() {
  yield takeEvery(aGetLiveScoreStatusRequest, getLiveScoreStatusSaga);
  yield takeLatest(aUpdateLiveScoreStatusRequest, updateLiveScoreSaga);
}

